module.exports = __webpack_public_path__ + "img/pt_tq.11f3b7b9.png";